import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';

export interface DialogData {   
  store_id: string
}
@Component({
  selector: 'app-print-label',
  templateUrl: './print-label.component.html',
  styleUrls: ['./print-label.component.css']
})
export class PrintLabelComponent implements OnInit {
  
  loading: false;  
  selectedMethod: string;
  public quantityError = false;
  public printLabelUrl: string;
  shippingData:any={};
  shipmentData: Array<any>=[];
  storeData: Array<any>=[];
  userData: Array<any>=[];
  public pleaseWait:string='';
  public boxLabel = true;

  constructor(public dialogRef: MatDialogRef<PrintLabelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router) {
   
  }

  ngOnInit() {
    this.getPrintLabelData();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  printPage= function (labelUrl) {
    this.printLabelUrl = labelUrl;
    //this.loading = true;
    this.pleaseWait="Please wait 5 second to load label ...";
    setTimeout(() => { 
      this.pleaseWait='';     
      window.print();  
          
    }, 5000);
    
  }

  getPrintLabelData = function () {
    this.loading = true;
    let printOptions = {
      id: localStorage.getItem("userID"),      
      store_id:this.data.store_id
    }

    this.CommonService.apiService(
      "POST",
      "store/printLabels",
      printOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
         this.shipmentData=response.data.labels;
         this.storeData=response.data.store;
         this.userData=response.data.user;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  printLabels(item, type = 'label') {
    const storeLabelData = {
      labels: type == 'label' ? [item] : this.shipmentData,
      store: this.storeData,
      user: this.userData
    };
    localStorage.setItem('storeLabelData', JSON.stringify(storeLabelData));

    const url = '/stores/shipping-labels/' + this.data.store_id;
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/print-label/print-label.component.ts